import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modeRadio", "configSection"]

  modeChanged() {
    const selected = this.modeRadioTargets.find(r => r.checked)
    if (!selected) return

    this.configSectionTarget.style.display = selected.value === "off" ? "none" : ""
  }
}
